module.exports = __webpack_public_path__ + "static/awards-logo9-354cb282111416d3900650fe72c61ddd.jpg";